import { blueTheme, darkTheme, blackTheme, lightTheme, coffeeTheme } from "../theme";
import { strings } from "../localization/LocalizedStrings";

export const ThemeManager = {
  currentTheme: () => {
    switch (localStorage.getItem("themeMode")) {
      case "light":
        return lightTheme;
      case "dark":
        return darkTheme;
      case "black":
        return blackTheme;
      case "blue":
        return blueTheme;
      case "coffee":
        return coffeeTheme;
      default:
        return blackTheme;
    }
  },
  currentThemeMode: () => {
    return localStorage.getItem("themeMode") ?? "black";
  },
  setTheme: (themeMode: ThemeMode) => {
    localStorage.setItem("themeMode", themeMode);
  },
  listOfThemeNames: () => {
    return [
      strings.black_mode,
      strings.dark_mode,
      strings.light_mode,
      strings.blue_mode,
      strings.coffee_mode
    ];
  },
  listOfThemeModes: () => {
    return ["black", "dark", "light", "blue", "coffee"];
  }
};

export type ThemeMode = "light" | "dark" | "black" | "blue" | "coffee";
